module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Filter</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-1\"><input type=\"checkbox\" name=\"additiveDynamicFilter\" id=\"additiveDynamicFilter\" ")
    ; __append(escapeFn(overridePrevious? 'checked' : ''))
    ; __append(" /></div>\r\n    <div class=\"col-md-8 nopadding-l\" style=\"margin-top: 3px;\">Override previous filter</div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-1\"><input type=\"checkbox\" name=\"respectDynamicFilter\" id=\"respectDynamicFilter\" ")
    ; __append(escapeFn(respectDynamicFilter? 'checked' : ''))
    ; __append(" /></div>\r\n    <div class=\"col-md-8 nopadding-l\" style=\"margin-top: 3px;\">Respect dynamic filter</div>\r\n</div>\r\n")
  }
  return __output;

}